/**
 * Ordina i layer mappa come il backend: position ASC, poi id ASC.
 * @param {Array<{ position?: number, id?: number }>} layers
 */
export function sortMapLayersByPosition(layers) {
  return [...layers].sort((a, b) => {
    const pa = Number(a.position ?? 0)
    const pb = Number(b.position ?? 0)
    if (pa !== pb) return pa - pb
    return Number(a.id ?? 0) - Number(b.id ?? 0)
  })
}

/**
 * Applica la lista API mantenendo stato UI locale (visibilità, file caricato, colori).
 * @param {Array<object>} apiLayers
 * @param {Array<object>} previousLayers
 * @param {string[]} colorPalette
 */
export function mergeMapLayersFromApi(apiLayers, previousLayers, colorPalette) {
  const prevById = new Map(previousLayers.map((l) => [l.id, l]))
  return sortMapLayersByPosition(apiLayers).map((layer, index) => {
    const prev = prevById.get(layer.id)
    return {
      ...layer,
      isOpen: prev?.isOpen ?? false,
      isFocused: prev?.isFocused ?? false,
      isLoading: prev?.isLoading ?? false,
      isLoaded: prev?.isLoaded ?? false,
      fileContent: prev?.fileContent ?? null,
      color: prev?.color ?? colorPalette[index % colorPalette.length]
    }
  })
}

/**
 * Arricchisce i layer grezzi dal GET con campi UI iniziali.
 * @param {Array<object>} rawLayers
 * @param {string[]} colorPalette
 */
export function enrichMapLayersForUi(rawLayers, colorPalette) {
  return sortMapLayersByPosition(rawLayers).map((layer, index) => ({
    ...layer,
    isOpen: false,
    isLoading: false,
    isLoaded: false,
    isFocused: false,
    fileContent: null,
    color: colorPalette[index % colorPalette.length]
  }))
}
